module.exports = __webpack_public_path__ + "static/media/toon1.49f0002c.png";